// The quote-request form is backed by a Google Workspace form, following the same pattern as the
// content site's Google Calendar booking links: the page posts directly to a Google-hosted
// endpoint, with no DataFabrIQ backend involved. The Google Form is configured (via its
// "Get email notifications for new responses" setting, or an Apps Script on-submit trigger) to
// email each submission to wink.jones@datafabriq.co.
//
// To wire up to a real form: create a Google Form with Name, Email, and Request questions, open
// "Get pre-filled link", fill in sample values, and copy the form ID and the entry.<n> parameter
// names from the generated URL into these constants.
const googleFormId = "1FAIpQLScoYq7jCXvphAV9sxz6d-ard1oll2jMuyhyOHy9nL9CJgYazw";
const googleFormNameField = "entry.200579737";
const googleFormEmailField = "entry.450287648";
const googleFormRequestField = "entry.152549135";

//https://docs.google.com/forms/d/e/1FAIpQLScoYq7jCXvphAV9sxz6d-ard1oll2jMuyhyOHy9nL9CJgYazw/viewform?usp=publish-editor
//https://docs.google.com/forms/d/e/1FAIpQLScoYq7jCXvphAV9sxz6d-ard1oll2jMuyhyOHy9nL9CJgYazw/viewform?usp=pp_url&entry.200579737=Name1&entry.450287648=Email1&entry.152549135=Test1

export interface QuoteRequest {
  name: string;
  email: string;
  request: string;
}

/**
 * Posts a quote request to the Google Form endpoint. Google Forms does not return CORS headers,
 * so the request uses mode "no-cors" and the response is opaque — a resolved promise means the
 * submission reached Google. Throws on network failure (offline or blocked request); callers
 * handle that with an inline fallback.
 */
export async function submitQuoteRequest(values: QuoteRequest): Promise<void> {
  const fields = new URLSearchParams({
    [googleFormNameField]: values.name.trim(),
    [googleFormEmailField]: values.email.trim(),
    [googleFormRequestField]: values.request.trim(),
  });

  await fetch(`https://docs.google.com/forms/d/e/${googleFormId}/formResponse`, {
    method: "POST",
    mode: "no-cors",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: fields.toString(),
  });
}
